import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL } from './PremiumButton';
import { FlameIcon, ArrowRightIcon, LockIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
type TimeLeft = {
  h: number;
  m: number;
  s: number;
};
function CountdownBoxes() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    h: 38,
    m: 29,
    s: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const boxes: {
    value: number;
    label: string;
  }[] = [{
    value: timeLeft.h,
    label: 'Horas'
  }, {
    value: timeLeft.m,
    label: 'Min'
  }, {
    value: timeLeft.s,
    label: 'Seg'
  }];
  return <div className="flex gap-2 sm:gap-3" data-id="element-387">
      {boxes.map(box => <div key={box.label} className="flex-1 min-w-0 bg-cream/[0.04] border border-cream/10 rounded-xl px-2 py-3 sm:px-5 sm:py-4 text-center" data-id="element-388">
          <div className="font-serif text-3xl sm:text-4xl text-cream leading-none" data-id="element-389">
            {String(box.value).padStart(2, '0')}
          </div>
          <div className="text-[10px] sm:text-xs text-sand/70 uppercase tracking-widest mt-1.5 sm:mt-2" data-id="element-390">
            {box.label}
          </div>
        </div>)}
    </div>;
}
export function NewOffer() {
  return <section id="pricing" className="py-12 md:py-24 bg-forest text-cream" data-id="element-391">
      <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-392">
        <div className="text-center mb-8 md:mb-12" data-id="element-393">
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-5 leading-tight" data-id="element-394">
            Empieza tu transformación{' '}
            <span className="italic text-peach" data-id="element-395">hoy</span>
          </h2>
          <p className="text-sand/80 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-396">
            Acceso inmediato al ebook, recetario, bitácora y todas las guías.
            Sin suscripciones. Sin letra pequeña.
          </p>
        </div>

        <div className="bg-cream/[0.02] border border-cream/15 rounded-3xl p-6 md:p-12" data-id="element-397">
          <div className="max-w-xl mx-auto text-center flex flex-col items-center" data-id="element-398">
            {/* Pricing */}
            <div className="flex items-baseline justify-center gap-3 mb-4" data-id="element-399">
              <span className="text-3xl md:text-4xl text-sand/50 line-through font-serif" data-id="element-400">
                $17.00
              </span>
              <span className="font-serif text-6xl md:text-7xl text-cream leading-none" data-id="element-401">
                $6.36
              </span>
            </div>
            <div className="inline-flex items-center gap-2 bg-burgundy text-cream rounded-full px-4 py-2 mb-5" data-id="element-402">
              <FlameIcon className="w-4 h-4 text-peach" data-id="element-403" />
              <span className="text-sm font-semibold" data-id="element-404">
                Ahorras 63% · Solo hoy
              </span>
            </div>
            <p className="text-sand/70 mb-8" data-id="element-405">Pago único · Acceso de por vida</p>

            {/* Countdown */}
            <div className="w-full max-w-sm mb-8" data-id="element-406">
              <CountdownBoxes data-id="element-407" />
            </div>

            {/* CTA */}
            <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" aria-label="Sí, quiero mi vientre plano por $6.36" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-peach text-forest rounded-full px-6 py-5 font-bold text-lg tracking-wide shadow-glow flex items-center justify-center gap-3 transition-shadow hover:shadow-glow-hover cursor-pointer" data-id="element-408">
              SÍ, QUIERO MI VIENTRE PLANO POR $6.36
              <ArrowRightIcon className="w-5 h-5" data-id="element-409" />
            </motion.a>

            <p className="text-center text-sand/60 text-sm leading-relaxed mt-4" data-id="element-410">
              Acceso inmediato tras el pago. Sin suscripciones, sin letra
              pequeña.
            </p>
          </div>

          <div className="border-t border-cream/10 mt-10 pt-8" data-id="element-411">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 text-sand/80" data-id="element-412">
              <div className="flex items-center gap-2" data-id="element-413">
                <LockIcon className="w-5 h-5 text-peach" data-id="element-414" />
                <span data-id="element-415">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-416">
                <ShieldCheckIcon className="w-5 h-5 text-peach" data-id="element-417" />
                <span data-id="element-418">Garantía 30 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-419">
                <SparklesIcon className="w-5 h-5 text-peach" data-id="element-420" />
                <span data-id="element-421">Acceso inmediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}